module.exports = __webpack_public_path__ + "img/monalisa.36e803b7.png";